var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBill = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 37 37",
  style: {
    enableBackground: "new 0 0 37 37"
  },
  xmlSpace: "preserve",
  className: "icon icon--bill",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.8 3.5H6.2c-1.5 0-2.6.9-2.6 2v26.8c0 .6.6 1 1.3 1 .2 0 .4 0 .6-.1l2.3-.9h.4l2.3.9c.6.2 1.3.2 2 0l2.3-.9h.4l2.3.9c.6.2 1.3.2 2 0l2.3-.9h.4l2.3.9c.6.2 1.3.2 2 0l2.3-.9h.4l2.3.9c.7.3 1.4 0 1.8-.5.1-.1.1-.3.1-.5V5.5c0-1.1-1.2-2-2.6-2zm.6 27.7-1.6-.6c-.6-.2-1.3-.2-1.9 0l-2.3.9h-.4l-2.3-.9c-.6-.2-1.3-.2-1.9 0l-2.3.9h-.4l-2.3-.9c-.6-.2-1.3-.2-1.9 0l-2.3.9h-.4l-2.3-.9c-.6-.2-1.3-.2-1.9 0l-1.6.6V6.1c0-.4.4-.6.9-.7h24c.5 0 .9.3.9.7v25.1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1 17.9H10.9c-.5 0-1 .4-1 1s.4 1 .9 1H26c.5 0 1-.4 1-1s-.4-1-.9-1zM26.1 13.3H10.9c-.5 0-1 .4-1 1s.4 1 .9 1H26c.5 0 1-.4 1-1 0-.5-.4-1-.9-1zM26.1 21.9H10.9c-.5 0-1 .4-1 1s.4 1 .9 1H26c.5 0 1-.4 1-1 0-.5-.4-1-.9-1z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconBill.5798c99b.svg";
export { ForwardRef as ReactComponent };